import React, { ChangeEvent, FunctionComponent, KeyboardEvent } from 'react';
import { ITestable } from '@belong/types';
import { ButtonChip, HiddenInput } from './ChoiceChip.styles';
import { KEYBOARD_KEYS } from '../../../helpers/variables';

export const TEST_ID = 'ChoiceChip';

export interface IChoiceChipProps extends ITestable {
  label: string;
  name: string;
  value: any;
  as?: 'checkbox' | 'radio';
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  isDisabled?: boolean;
  isSelected?: boolean;
}

/**
 * Single, selectable, rounded choice button
 */
const ChoiceChip: FunctionComponent<IChoiceChipProps> = props => {
  const {
    label,
    value,
    isSelected = false,
    isDisabled = false,
    onChange,
    as = 'checkbox',
    name,
    ...otherProps
  } = props;
  const id = `${name}-${value}`.toLowerCase().replace(/\W/g, '-');

  // allow checkbox interaction via enter key
  const keyboardHandler = (event: KeyboardEvent<HTMLInputElement>): void => {
    if (as === 'checkbox' && event.key === KEYBOARD_KEYS.ENTER) {
      event.currentTarget.click();
    }
  };

  const changeHandler = (event: ChangeEvent<HTMLInputElement>): void => {
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <label {...otherProps} htmlFor={id}>
      <HiddenInput
        id={id}
        type={as}
        name={name}
        value={value}
        checked={isSelected}
        disabled={isDisabled}
        onChange={changeHandler}
        onKeyDown={keyboardHandler}
      />
      <ButtonChip>
        <span>{label}</span>
      </ButtonChip>
    </label>
  );
};

ChoiceChip.displayName = 'ChoiceChip';

export default ChoiceChip;
